/**
 * Builds an http query string
 *
 * @param {object} payload Key value pairs to be accessed in PHP via the $_POST variable
 *
 * @return {string} Query string ie 'key1=value&key2=value' etc.
 */
const httpBuildQuery = payload => {
	// Make a new URL object with an arbitrary url, then add the params to access in php with $_POST -- this is similar to qs.stringify({key: value})
	const dataUrl = new URL(window.location);

	for (const key in payload) {
		if (dataUrl) { // eslint requires an if statement in for in loops
			dataUrl.searchParams.append(key, payload[key]);
		}
	}

	return dataUrl.searchParams.toString();
};

export default httpBuildQuery;
